import {
  Box,
  TextField,
  Button,
  Typography,
  Select,
  MenuItem,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  Alert,
  FormHelperText,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import CountrySelect from "components/CountrySelect";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useFormik } from "formik";
import * as yup from "yup";
import { api } from "common";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const InputStyleProps = {
  InputLabelProps: {
    style: {
      fontFamily: "Roboto",
      fontWeight: 500,
      fontSize: "14px",
      lineHeight: "19.6px",
      color: "white",
    },
  },
  sx: {
    fontFamily: "Roboto",
    fontWeight: 400,
    fontSize: "16px",
    color: "#E5E5EA",
    width: "100%",
    "& ::before": {
      borderBottom: "1px solid white !important",
    },
    "& .MuiInputBase-input": {
      color: "#E5E5EA",
    },
    "&.MuiInputBase-root": {
      "&::before": {
        borderBottom: "1px solid white !important",
      },
    },
  },
};

const SignUpForm = ({ switchToSignIn, setShowSignUp }) => {
  const settings = useSelector((state) => state.settingsdata.settings);
  const dispatch = useDispatch();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [signUpResponse, setSignUpResponse] = useState({
    msg: "",
    type: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const {
    mainSignUp,
    validateReferer,
    countries,
    requestSignupOtp,
    clearSignupOtpState,
  } = api;
  const navigate = useNavigate();

  const validationSchema = yup.object({
    firstName: yup
      .string()
      .min(2, t("first_name_min"))
      .max(20, t("first_name_max"))
      .matches(/^[A-Za-z]+$/, t("first_name_alpha"))
      .required(t("first_name_required")),
    lastName: yup
      .string()
      .min(2, t("last_name_min"))
      .max(20, t("last_name_max"))
      .matches(/^[A-Za-z]+$/, t("last_name_alpha"))
      .required(t("last_name_required")),
    phone: yup
      .string()
      .required(t("phone_required"))
      .test("is-valid-phone", t("mobile_no_blank_error"), function (value) {
        const { selectedcountry } = this.parent;
        if (selectedcountry.label.toLowerCase() === "nigeria") {
          return /^[7-9][0-1][0-9]{8}$/.test(value);
        } else if (selectedcountry.label.toLowerCase() === "cameroon") {
          return /^[79][0-9]{7,8}$/.test(value);
        }
        return true;
      }),
    password: yup
      .string()
      .min(8, t("password_min"))
      .matches(/[a-z]/, t("password_lowercase"))
      .matches(/[A-Z]/, t("password_uppercase"))
      .matches(/[0-9]/, t("password_number"))
      .matches(/^\S*$/, t("password_must_not_contain_whitespaces"))
      .matches(/[!@#$%^&*(),.?":{}|<>]/, t("password_special"))
      .required(t("password_required")),
    confirmpassword: yup
      .string()
      .oneOf([yup.ref("password"), null], t("confirm_password_not_match_err"))
      .required(t("confirm_password_required")),
    usertype: yup
      .string()
      .oneOf(["customer", "driver"], t("invalid_user_type"))
      .required(t("user_type_required")),
    referralId: yup.string().nullable(),
    otpMethod: yup
      .string()
      .oneOf(
        ["sms", "whatsapp"],
        t("invalid_otp_method") || "Invalid OTP method",
      )
      .required(
        t("otp_method_required") || "Please select OTP delivery method",
      ),
    selectedcountry: yup
      .object()
      .shape({
        label: yup.string().required(),
        phone: yup.string().required(),
        code: yup.string().required(),
      })
      .nullable()
      .required(t("country_required")),
  });

  useEffect(() => {
    if (settings) {
      for (let i = 0; i < countries.length; i++) {
        if (countries[i].label === settings.country) {
          setFieldValue("selectedcountry", countries[i]);
        }
      }
    }
  }, [settings, countries]);

  // const onSubmit = async (data) => {
  //   setSignUpResponse({
  //     msg: "",
  //     type: "",
  //   });
  //   new Promise((resolve, reject) => {
  //     setIsLoading(true);

  //     let formattedNum = data.phone.replace(/ /g, "");
  //     const userData = {
  //       ...data,
  //       mobile: `+${data.selectedcountry.phone}${formattedNum}`,
  //     };

  //     delete userData.confirmpassword;

  //     api.checkUserExists(userData).then((res) => {
  //       if (res.users && res.users.length > 0) {
  //         setSignUpResponse({ type: "error", msg: t("user_exists") });
  //         setIsLoading(false);
  //       } else if (!!res.error) {
  //         setSignUpResponse({
  //           type: "error",
  //           msg: t("user_verification_error"),
  //         });
  //         setIsLoading(false);
  //       } else {
  //         if (userData.referralId && userData.referralId.length > 0) {
  //           validateReferer(userData.referralId)
  //             .then((referralInfo) => {
  //               if (referralInfo.uid) {
  //                 delete userData.country;
  //                 mainSignUp({
  //                   ...userData,
  //                   signupViaReferral: referralInfo.uid,
  //                 }).then((res) => {
  //                   if (res.uid) {
  //                     resetForm();
  //                     setIsLoading(false);
  //                     setSignUpResponse({
  //                       msg: t("reg_success"),
  //                       type: "success",
  //                     });
  //                     navigate("/login");
  //                   } else {
  //                     // setSignUpResponse({
  //                     //   type: "error",
  //                     //   msg: t("reg_error"),
  //                     // });
  //                     setSignUpResponse({
  //                       type: "success",
  //                       msg: t("reg_success"),
  //                     });
  //                     navigate("/login");

  //                     setIsLoading(false);
  //                     reject();
  //                   }
  //                 });
  //               } else {
  //                 setSignUpResponse({
  //                   type: "error",
  //                   msg: t("referer_not_found"),
  //                 });
  //                 setIsLoading(false);
  //               }
  //             })
  //             .catch((error) => {
  //               setSignUpResponse({
  //                 type: "error",
  //                 msg: t("referer_not_found"),
  //               });
  //               setIsLoading(false);
  //             });
  //         } else {
  //           delete userData.selectedcountry;
  //           mainSignUp(userData).then((res) => {
  //             if (res.uid) {
  //               resetForm();
  //               setIsLoading(false);
  //               resolve();
  //             } else {
  //               // setSignUpResponse({
  //               //   type: "error",
  //               //   msg: t("reg_error"),
  //               // });
  //               setIsLoading(false);
  //               setSignUpResponse({
  //                 type: "success",
  //                 msg: t("reg_success"),
  //               });
  //               navigate("/login");
  //             }
  //           });
  //         }
  //       }
  //     });
  //   });
  // };

  const onSubmit = async (data) => {
    setSignUpResponse({
      msg: "",
      type: "",
    });

    try {
      setIsLoading(true);

      let formattedNum = data.phone.replace(/ /g, "");
      const userData = {
        ...data,
        mobile: `+${data.selectedcountry.phone}${formattedNum}`,
      };

      delete userData.confirmpassword;

      // Request OTP for signup verification
      const result = await dispatch(requestSignupOtp(userData, data.otpMethod));

      if (result.success) {
        setIsLoading(false);
        // Navigate to OTP verification page
        navigate("/verify-otp", {
          state: {
            userData: userData,
            deliveryMethod: data.otpMethod,
            contact: userData.mobile,
          },
        });
      } else {
        setSignUpResponse({
          type: "error",
          msg: result.error || t("otp_request_failed") || "Failed to send OTP",
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Registration error:", error);
      setSignUpResponse({
        type: "error",
        msg: t("reg_error"),
      });
      setIsLoading(false);
    }
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      password: "",
      phone: "",
      confirmpassword: "",
      selectedcountry: null,
      usertype: "",
      referralId: "",
      otpMethod: "whatsapp",
      entryType: null,
      contact: "",
      otp: "",
      verificationId: null,
    },
    validationSchema,
    onSubmit: onSubmit,
  });

  return (
    <Box
      component={"form"}
      sx={{
        boxSizing: "border-box",
        width: "100%",
        maxWidth: "800px",
        margin: "auto",
        padding: "2rem",
        // borderRadius: "10px",
        // bgcolor: "rgba(218, 216, 216, 0.22)",
        // backdropFilter: "blur(10px)",
        // border: "2px solid white",
        color: "#fff",

        "@media (max-width: 768px)": { padding: "1rem" },
      }}
      onSubmit={handleSubmit}
    >
      <Box
        sx={{ position: "absolute", inset: 0, bgcolor: "rgba(0, 0, 0, 0.5)" }}
      ></Box>
      <Typography
        variant="h4"
        sx={{
          position: "relative",
          color: "white",
          textAlign: "center",
          marginBottom: "1rem",
          fontWeight: "500",
          zIndex: 1,
        }}
      >
        {t("signup")}
      </Typography>
      <Typography
        sx={{
          position: "relative",
          textAlign: "center",
          marginBottom: "2rem",
          color: "text.white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
        }}
      >
        {`${t("have_account")} `}
        <Button
          sx={{
            color: "#9EC556",
            textTransform: "none",
            "&:hover": { color: "#AFCD56" },
          }}
          onClick={switchToSignIn}
        >
          {t(`SignIn`)}
        </Button>
      </Typography>

      {signUpResponse.msg && (
        <Alert severity={signUpResponse.type} sx={{ mb: 2 }}>
          {signUpResponse.msg}
        </Alert>
      )}

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "1.5rem",

          "@media (max-width: 768px)": {
            gridTemplateColumns: "1fr",
          },
        }}
      >
        {/* First Name */}
        <TextField
          fullWidth
          label={t("first_name")}
          id="firstName"
          value={values.firstName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.firstName && touched.firstName}
          helperText={touched.firstName && errors.firstName}
          variant="standard"
          {...InputStyleProps}
        />

        {/* Last Name */}
        <TextField
          fullWidth
          label={t("last_name")}
          id="lastName"
          value={values.lastName}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.lastName && touched.lastName}
          helperText={touched.lastName && errors.lastName}
          variant="standard"
          {...InputStyleProps}
        />

        {/* User Type */}
        <FormControl
          variant="standard"
          fullWidth
          error={!!errors.usertype && touched.usertype}
          sx={{ gridColumn: "1 / -1" }}
        >
          <InputLabel id="demo-simple-select-label">
            <Typography color={"#fff"}>{t("user_type")}</Typography>
          </InputLabel>
          <Select
            fullWidth
            value={values.usertype}
            onChange={handleChange}
            onBlur={handleBlur}
            id="usertype"
            name="usertype"
            aria-label={t("user_type")}
            variant="standard"
            sx={{
              color: "#e5e5ea",
              "&::before": {
                borderBottom: "1px solid white !important",
              },
            }}
          >
            <MenuItem value="customer">{t("customer")}</MenuItem>
            <MenuItem value="driver">{t("driver")}</MenuItem>
          </Select>
          <FormHelperText>{touched.usertype && errors.usertype}</FormHelperText>
        </FormControl>

        {/* Phone Country */}
        <CountrySelect
          fullWidth
          label={t("select_country")}
          countries={countries}
          value={values.selectedcountry}
          onChange={(event, value) =>
            handleChange({
              target: {
                name: "selectedcountry",
                value: value || "",
              },
            })
          }
          readOnly={!settings.AllowCountrySelection}
          {...InputStyleProps}
        />

        {/* Phone Number */}
        <TextField
          fullWidth
          label={t("phone")}
          id="phone"
          type="tel"
          value={values.phone}
          onChange={(e) => {
            const value = e.target.value.replace(/[^0-9]/g, "");
            setFieldValue("phone", value);
          }}
          onBlur={handleBlur}
          error={!!errors.phone && touched.phone}
          helperText={touched.phone && errors.phone}
          required
          variant="standard"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
          {...InputStyleProps}
        />

        {/* Password */}
        <TextField
          fullWidth
          label={t("password")}
          type={showPassword ? "text" : "password"}
          id="password"
          value={values.password}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.password && touched.password}
          helperText={touched.password && errors.password}
          variant="standard"
          {...InputStyleProps}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPassword((prev) => !prev)}
                  sx={{ color: "white" }}
                >
                  {showPassword ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* Confirm Password */}
        <TextField
          fullWidth
          label={t("confirm_password")}
          type={showConfirmPassword ? "text" : "password"}
          id="confirmpassword"
          value={values.confirmpassword}
          onChange={handleChange}
          onBlur={handleBlur}
          error={!!errors.confirmpassword && touched.confirmpassword}
          helperText={touched.confirmpassword && errors.confirmpassword}
          variant="standard"
          {...InputStyleProps}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  sx={{ color: "white" }}
                  onClick={() => setShowConfirmPassword((prev) => !prev)}
                >
                  {showConfirmPassword ? (
                    <VisibilityOffIcon />
                  ) : (
                    <VisibilityIcon />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        {/* OTP Delivery Method */}
        <FormControl
          variant="standard"
          fullWidth
          error={!!errors.otpMethod && touched.otpMethod}
          sx={{ gridColumn: "1 / -1" }}
        >
          <InputLabel id="otp-method-label">
            <Typography color={"#fff"}>
              {t("otp_delivery_method") || "Receive verification code via"}
            </Typography>
          </InputLabel>
          <Select
            fullWidth
            value={values.otpMethod}
            onChange={handleChange}
            onBlur={handleBlur}
            id="otpMethod"
            name="otpMethod"
            aria-label={t("otp_delivery_method") || "OTP Delivery Method"}
            variant="standard"
            sx={{
              color: "#e5e5ea",
              "&::before": {
                borderBottom: "1px solid white !important",
              },
            }}
          >
            <MenuItem value="whatsapp">
              {t("via_whatsapp") || "WhatsApp"}
            </MenuItem>
            <MenuItem value="sms">
              {t("via_sms") || "SMS (Text Message)"}
            </MenuItem>
          </Select>
          <FormHelperText sx={{ color: "#e5e5ea" }}>
            {touched.otpMethod && errors.otpMethod
              ? errors.otpMethod
              : t("otp_helper_text") ||
                "We'll send a 6-digit code to verify your account"}
          </FormHelperText>
        </FormControl>
      </Box>

      {/* Referral ID */}
      {/* <TextField
        labelText={t("referralId")}
        id="referralId"
        sx={{
          width: "100%",
        }}
        formControlProps={{
          fullWidth: true,
        }}
        inputProps={{
          endAdornment: (
            <InputAdornment position="start">
              <AccountBox />
            </InputAdornment>
          ),
        }}
        value={values.referralId}
        onChange={handleChange}
        onBlur={handleBlur}
        error={!!errors.referralId && touched.referralId}
        helperText={touched.referralId && errors.referralId}
        variant="standard"
      /> */}

      <Box display={"flex"}>
        <Button
          variant="contained"
          sx={{
            mt: 4,
            py: 1.5,
            width: "50%",
            borderRadius: "25px",
            marginInline: "auto",
            backgroundColor: "#5BAA59",
            color: "#fff",
            fontSize: "1.1rem",
            textTransform: "none",
            background:
              "linear-gradient(90deg, #59A959 0%, #79B357 65.87%, #AFCD56 95.67%)",
            "&:hover": { bgcolor: "#F8DBF2" },
            "&:disabled": { background: "rgba(255, 255, 255, 0.5)" },
            position: "relative",
          }}
          type="submit"
          disabled={isLoading || Object.keys(errors).length > 0}
        >
          {isLoading ? t("loading") : t("signup")}
        </Button>
      </Box>
    </Box>
  );
};

export default SignUpForm;
